<mat-card class="thumbnail-icon-card mat-elevation-z4" [ngClass]="size ? size : ''" matRipple>
  <mat-card-content>
    <div class="thumbnail-icon-card_thumbnail" [style.background-image]="'url(' + thumbnail + ')'"></div>
    <div class="thumbnail-icon-card_text">
      <p class="mat-display-3 u-text-no-margin u-text-center">
        {{ text }}
      </p>
    </div>
  </mat-card-content>
</mat-card>